export const prelandsTypes = {
  setPftpswc: 'set/pftpswc',
  setPftps: 'set/pftps',
};
